var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleClick}},[_c(_vm.config.component,{ref:"component",tag:"component",staticClass:"component",style:(_vm.getStyle(_vm.config.style)),attrs:{"prop-value":_vm.config.propValue,"element":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }